import { RouteConfig } from './types';
import { lazy } from 'react';

const ReengagePage = lazy(() => import('../pages/customers/ReengagePage'));
const FinanceOverviewPage = lazy(() => import('../pages/customers/FinanceOverviewPage'));
const DueReportPage = lazy(() => import('../pages/customers/DueReportPage'));
const CollectionsPage = lazy(() => import('../pages/customers/CollectionsPage'));
const AgingPage = lazy(() => import('../pages/customers/AgingPage'));
const UnsentInvoicesPage = lazy(() => import('../pages/customers/UnsentInvoicesPage'));
const FinanceAlertsPage = lazy(() => import('../pages/customers/FinanceAlertsPage'));

export const customerRoutes: RouteConfig[] = [
  { path: '/app/customers/reengage', element: ReengagePage, requiresLayout: true, requiredPermissions: ['customer.read'] },
  { path: '/customers/reengage', element: ReengagePage, requiresLayout: true, requiredPermissions: ['customer.read'] },
  { path: '/app/customers/finance', element: FinanceOverviewPage, requiresLayout: true, requiredPermissions: ['customer_finance.read'] },
  { path: '/app/customers/dues', element: DueReportPage, requiresLayout: true, requiredPermissions: ['customer_finance.read'] },
  { path: '/app/customers/collections', element: CollectionsPage, requiresLayout: true, requiredPermissions: ['customer_collections.read'] },
  { path: '/app/customers/aging', element: AgingPage, requiresLayout: true, requiredPermissions: ['customer_finance.read'] },
  { path: '/app/customers/unsent', element: UnsentInvoicesPage, requiresLayout: true, requiredPermissions: ['customer_finance.read'] },
  { path: '/app/customers/alerts', element: FinanceAlertsPage, requiresLayout: true, requiredPermissions: ['customer_finance.read'] },
];
